import PromotionsInnerPageB from './PromotionsInnerPageB';
export default PromotionsInnerPageB;
